import { useState } from "react";
import onClickOutside from "react-onclickoutside";

function Dropdown({
  selectedCourse,
  setSelectedCourse,
  courseData,
  addCourse,
}) {
  const [isActive, setIsActive] = useState(false);

  const handleAddCourse = () => {
    setSelectedCourse(null);
    setSelectedCourse({ course_name: "", course_description: "" });
    setIsActive(false);
  };

  Dropdown.handleClickOutside = () => {
    setIsActive(false);
  };

  let addCourseComp = (
    <div onClick={handleAddCourse} className="dropdown-item">
      Add Course
    </div>
  );

  return (
    <div className="dropdown">
      <div className="dropdown-btn" onClick={(e) => setIsActive(!isActive)}>
        {(selectedCourse && selectedCourse.course_name) || (
          <span className="select-placeholder">Select Course</span>
        )}
        <span className="fas fa-caret-down"></span>
      </div>
      {isActive && (
        <div className="dropdown-content" style={{ zIndex: "10000" }}>
          {addCourseComp}
          {courseData?.map((option) => (
            <div
              key={option.course_name}
              onClick={(e) => {
                setSelectedCourse(option);
                if (addCourse) setSelectedCourse(option);
                setIsActive(false);
              }}
              className="dropdown-item"
            >
              {option.course_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const clickOutsideConfig = {
  handleClickOutside: () => Dropdown.handleClickOutside,
};

export default onClickOutside(Dropdown, clickOutsideConfig);
